import { useTranslation } from 'react-i18next';

import { PageLayout } from 'coreOld/components';
import { Spinner } from 'coreOld/elements';
import { useAppSelector } from 'coreOld/hooks';
import { CompanyParts, CompanyPartRowDetails } from 'partsOld/components';
import { companyPartListDefaultPayload } from 'partsOld/constants';

import { filtersConfig, advancedFiltersConfig } from './configs';

const CompanyPartsPage = () => {
  const { t } = useTranslation();
  const { filteredCount } = useAppSelector((state) => state.table);

  const isLoading = filteredCount && filteredCount?.isLoading;

  const subTitle = isLoading ? <Spinner /> : filteredCount?.count || 0;

  return (
    <PageLayout title={t('labelCompanyParts')} subTitle={subTitle}>
      <CompanyParts
        filtersConfig={filtersConfig()}
        advancedFiltersConfig={advancedFiltersConfig}
        initialFilters={companyPartListDefaultPayload.filters}
      />
      <CompanyPartRowDetails />
    </PageLayout>
  );
};

export default CompanyPartsPage;
